import * as React from 'react';
import '../../../context/actions.js';
import '../../../context/reducer.js';
import { useProductData } from '../../../context/product-context-hooks.js';
import '../../../context/ProductContext.js';
import '../../../context/CmsContext.js';
import { UnpublishedProductEcommContent } from './UnpublishedProductEcommContent.js';

const UnpublishedProductEcommContentContainer = ()=>{
    const { activeVariant  } = useProductData();
    const productColor = activeVariant.facets.color;
    return /*#__PURE__*/ React.createElement(UnpublishedProductEcommContent, {
        productColor: productColor
    });
};

export { UnpublishedProductEcommContentContainer };
//# sourceMappingURL=UnpublishedProductEcommContentContainer.js.map
